export default "__VITE_ASSET__Do2UaKyo__"